import { render, staticRenderFns } from "./CsrView.vue?vue&type=template&id=3b684a05"
import script from "./CsrView.vue?vue&type=script&lang=js"
export * from "./CsrView.vue?vue&type=script&lang=js"
import style0 from "./CsrView.vue?vue&type=style&index=0&id=3b684a05&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports